import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { isAuthenticated, userHasAnyRoleOrGroup } from "../utils/auth";
import { rememberReturnUrl } from "../utils/authReturn";

export {
  AUTH_RETURN_KEY,
  getSafeReturnPath,
  rememberReturnUrl,
  consumeReturnUrl,
} from "../utils/authReturn";

const PrivateRoute = ({ allowedGroups = [], redirectTo = "/login" }) => {
  const location = useLocation();
  const authed = isAuthenticated();

  if (!authed) {
    const returnTo = `${location.pathname}${location.search || ""}`;
    rememberReturnUrl(returnTo);
    return (
      <Navigate
        to={redirectTo}
        replace
        state={{ from: location }}
      />
    );
  }

  const hasPermission = userHasAnyRoleOrGroup(allowedGroups);

  return hasPermission ? <Outlet /> : <Navigate to="/403" replace />;
};

export default PrivateRoute;
